/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
class r{constructor(){this._programCache=new Map}destroy(){for(const r of this._programCache.values())r.destroy();this._programCache.clear()}getProgram(r,e,t,a,o){const s=r.getShaderKey(e,t,a,o);let c=this._programCache.get(s);return c||(c=r.getProgram(e,t,a,o),this._programCache.set(s,c)),c}}export{r as TechniqueProgramCache};
